export const DEFAULT_WIDTH = 550;
export const DEFAULT_MIN_WIDTH = 550;
export const DEFAULT_MIN_HEIGHT = 400;

// error codes
export const WORKFLOW_NOT_FOUND_CODE = 'WORKFLOW_NOT_FOUND';
export const NO_RESOURCE_PERMISSIONS = 'NO_RESOURCE_PERMISSIONS';
